<template>
  <div class="timetable1" @scroll="hiddenXskc">
    <Header  title="课程表" ></Header>
    <div v-if="schoolCode !== '10294'">
      <div class="timetable_top1">
      <van-field
        readonly
        clickable
        placeholder="周次"
        v-model="curWeek"
        @click="
          showPicker = true;
          change = false;
        "
      />
      <i class="week-arrow"></i>
      <van-field  v-if="this.schoolCode == 10894" style="margin-left: 15px;font-size: 12px;width: 60px;" v-model="jgxm"  placeholder="按老师查询"  @input="jgxmcx" />
    
      
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @cancel="showPicker = false"
          @confirm="onConfirm"
          :item-height="35"
          :default-index="defaultIndex"
        />
      </van-popup>

      <van-popup v-model="showJgxx" position="bottom">
        <van-picker
          show-toolbar
          :columns="jgxxColumns"
          @cancel="showJgxx = false"
          @confirm="onJgxxConfirm"
          :item-height="35"
          :default-index="defaultIndex"
        />
      </van-popup>

      <div class="time-right">
        <!-- 时间模式 -->
        <van-field
          readonly
          clickable
          placeholder=""
          v-model="timeMode"
          @click="modePicker = true"
        />
        <i class="week-arrow"></i>
        <van-popup v-model="modePicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="modeColumns"
            @cancel="modePicker = false"
            @confirm="modeConfirm"
            :item-height="35"
            :default-index="defaultIndex1"
          />
        </van-popup>
        <div class="currentTime" @click="fn1(nowzc, undefined)">今</div>
      </div>
    </div>
    <div class="timetable_list">
      <div class="period" style="margin-bottom: 70px">
        <div
          :style="schoolCode == '10762' ? 'width:62px' : ''"
          v-if="(this.schoolCode == 10759||this.schoolCode == 10488) && this.weekday == 0"
        >
          节<br />次
        </div>
        <div :style="schoolCode == '10762' ? 'width:62px' : ''" v-else>
          {{ this.weekday }}<br />月
        </div>
        <ul v-if="schoolCode == '10762'">
          <li
            style="width: 62px;height: 131px;line-height: 131px;"
            v-for="(item, index) in nodeList"
            :key="index"
          >
            {{ item }}
          </li>
        </ul>
        <ul v-else>
          <li v-for="(item, index) in nodeList" :key="index">
            {{ item.nodeNumber }}
          </li>
          <li v-if=" schoolCode == '10045'"></li>
          <li v-if=" schoolCode == '10045'"></li>
        </ul>
      </div>
      <div class="table-right">
        <div class="week-nav">
          <ul>
            <li
              :style="
                curDay == '星期' + item.xqmc && nowzc == item.zc
                  ? 'background-color:#12DDD6'
                  : ''
              "
              v-for="(item, index) in dateWeekList"
              :key="index"
            >
              <span>周{{ item.xqmc }}</span>
              <p v-if="item.zc != 'all'">{{ dateSub(item.mxrq) }}</p>
            </li>
          </ul>
        </div>
        <div class="course-content">
          <!-- 周日 -->
          <div class="course-form" id="Sunday">
            <ul class="myul">
              <template v-for="(list, active) in SundayList">
                <template v-for="(elem, num) in list">
                  <li
                    ref="ranText"
                    :style="
                      elem[0].courseName
                        ? 'top:' +
                          calcOpt(elem[0].weekNoteDetail, 0) +
                          'height:' +
                          calcOpt(elem[0].weekNoteDetail, 1)
                        : ''
                    "
                    @click="courseDetail(elem)"
                    :key="active + num"
                  >
                    <van-swipe
                      class="my-swipe"
                      :autoplay="0"
                      indicator-color="white"
                      :loop="false"
                      @change="
                        index => {
                          return onChange(index, elem);
                        }
                      "
                    >
                      <van-swipe-item
                        v-for="(item, index) in elem"
                        :key="index"
                        :style="
                          item.courseName
                            ? 'background-color:' + calcColor(index, 0,num,item.courseName,item.jx0404id)
                            : ''
                        "
                      >
                        <span v-show="item.courseName"
                          >{{ item.courseName }} - {{ item.teacherName }} @
                          {{ item.classroomName }}
                          <span v-if="schoolCode == '14345' || schoolCode == '12989'"
                            >-{{ item.ktmc }}</span
                          >
                          <span v-if="schoolCode == '10488'"
                            > -第{{ item.kkzc }}周</span
                          >
                        </span>
                        <span v-show="!item.courseName"></span>
                        <p
                          v-if="item.buttonCode != 0"
                          v-text="
                            item.buttonCode == 2 ? '进入课堂' : '创建课堂'
                          "
                        ></p>
                      </van-swipe-item>
                      <template #indicator>
                        <div v-if="elem.length > 1" class="custom-indicator">
                          {{ elem.current + 1 }}/{{ elem.length }}
                        </div>
                      </template>
                    </van-swipe>
                  </li>
                </template>
              </template>
            </ul>
          </div>
          <!-- 周一 -->
          <div class="course-form" id="monday">
            <ul class="myul">
              <template v-for="(list, active) in mondayList">
                <template v-for="(elem, num) in list">
                  <li
                    ref="ranText"
                    :style="
                      elem[0].courseName
                        ? 'top:' +
                          calcOpt(elem[0].weekNoteDetail, 0) +
                          'height:' +
                          calcOpt(elem[0].weekNoteDetail, 1)
                        : ''
                    "
                    @click="courseDetail(elem)"
                    :key="active + num"
                  >
                    <van-swipe
                      class="my-swipe"
                      :autoplay="0"
                      indicator-color="white"
                      :loop="false"
                      @change="
                        index => {
                          return onChange(index, elem);
                        }
                      "
                    >
                      <van-swipe-item
                        v-for="(item, index) in elem"
                        :key="index"
                        :style="
                          item.courseName
                            ? 'background-color:' + calcColor(index, 1,num,item.courseName,item.jx0404id)
                            : ''
                        "
                      >
                        <span v-show="item.courseName"
                          >{{ item.courseName }} - {{ item.teacherName }} @
                          {{ item.classroomName }}
                          <span v-if="schoolCode == '14345' || schoolCode == '12989'"
                            >-{{ item.ktmc }}</span
                          >
                          <span v-if="schoolCode == '10488'"
                            > -第{{ item.kkzc }}周</span
                          >
                        </span>
                        <span v-show="!item.courseName"></span>
                        <p
                          v-if="item.buttonCode != 0"
                          v-text="
                            item.buttonCode == 2 ? '进入课堂' : '创建课堂'
                          "
                        ></p>
                      </van-swipe-item>
                      <template #indicator>
                        <div v-if="elem.length > 1" class="custom-indicator">
                          {{ elem.current + 1 }}/{{ elem.length }}
                        </div>
                      </template>
                    </van-swipe>
                  </li>
                </template>
              </template>
            </ul>
          </div>
          <!-- 周二 -->
          <div class="course-form" id="Tuesday">
            <ul class="myul">
              <template v-for="(list, active) in TuesdayList">
                <template v-for="(elem, num) in list">
                  <li
                    ref="ranText"
                    :style="
                      elem[0].courseName
                        ? 'top:' +
                          calcOpt(elem[0].weekNoteDetail, 0) +
                          'height:' +
                          calcOpt(elem[0].weekNoteDetail, 1)
                        : ''
                    "
                    @click="courseDetail(elem)"
                    :key="active + num"
                  >
                    <van-swipe
                      class="my-swipe"
                      :autoplay="0"
                      indicator-color="white"
                      :loop="false"
                      @change="
                        index => {
                          return onChange(index, elem);
                        }
                      "
                    >
                      <van-swipe-item
                        v-for="(item, index) in elem"
                        :key="index"
                        :style="
                          item.courseName
                            ? 'background-color:' + calcColor(index, 0,num,item.courseName,item.jx0404id)
                            : ''
                        "
                      >
                        <span v-show="item.courseName"
                          >{{ item.courseName }} - {{ item.teacherName }} @
                          {{ item.classroomName }}
                          <span v-if="schoolCode == '14345' || schoolCode == '12989'"
                            >-{{ item.ktmc }}</span
                          >
                          <span v-if="schoolCode == '10488'"
                            > -第{{ item.kkzc }}周</span
                          >
                        </span>
                        <span v-show="!item.courseName"></span>
                        <p
                          v-if="item.buttonCode != 0"
                          v-text="
                            item.buttonCode == 2 ? '进入课堂' : '创建课堂'
                          "
                        ></p>
                      </van-swipe-item>
                      <template #indicator>
                        <div v-if="elem.length > 1" class="custom-indicator">
                          {{ elem.current + 1 }}/{{ elem.length }}
                        </div>
                      </template>
                    </van-swipe>
                  </li>
                </template>
              </template>
            </ul>
          </div>
          <!-- 周三 -->
          <div class="course-form" id="Wednesday">
            <ul class="myul">
              <template v-for="(list, active) in WednesdayList">
                <template v-for="(elem, num) in list">
                  <li
                    ref="ranText"
                    :style="
                      elem[0].courseName
                        ? 'top:' +
                          calcOpt(elem[0].weekNoteDetail, 0) +
                          'height:' +
                          calcOpt(elem[0].weekNoteDetail, 1)
                        : ''
                    "
                    @click="courseDetail(elem)"
                    :key="active + num"
                  >
                    <van-swipe
                      class="my-swipe"
                      :autoplay="0"
                      indicator-color="white"
                      :loop="false"
                      @change="
                        index => {
                          return onChange(index, elem);
                        }
                      "
                    >
                      <van-swipe-item
                        v-for="(item, index) in elem"
                        :key="index"
                        :style="
                          item.courseName
                            ? 'background-color:' + calcColor(index, 1,num,item.courseName,item.jx0404id)
                            : ''
                        "
                      >
                        <span v-show="item.courseName"
                          >{{ item.courseName }} - {{ item.teacherName }} @
                          {{ item.classroomName }}
                          <span v-if="schoolCode == '14345' || schoolCode == '12989'"
                            >-{{ item.ktmc }}</span
                          >
                          <span v-if="schoolCode == '10488'"
                            > -第{{ item.kkzc }}周</span
                          >
                        </span>
                        <span v-show="!item.courseName"></span>
                        <p
                          v-if="item.buttonCode != 0"
                          v-text="
                            item.buttonCode == 2 ? '进入课堂' : '创建课堂'
                          "
                        ></p>
                      </van-swipe-item>
                      <template #indicator>
                        <div v-if="elem.length > 1" class="custom-indicator">
                          {{ elem.current + 1 }}/{{ elem.length }}
                        </div>
                      </template>
                    </van-swipe>
                  </li>
                </template>
              </template>
            </ul>
          </div>
          <!-- 周四 -->
          <div class="course-form" id="Thursday">
            <ul class="myul">
              <template v-for="(list, active) in ThursdayList">
                <template v-for="(elem, num) in list">
                  <li
                    ref="ranText"
                    :style="
                      elem[0].courseName
                        ? 'top:' +
                          calcOpt(elem[0].weekNoteDetail, 0) +
                          'height:' +
                          calcOpt(elem[0].weekNoteDetail, 1)
                        : ''
                    "
                    @click="courseDetail(elem)"
                    :key="active + num"
                  >
                    <van-swipe
                      class="my-swipe"
                      :autoplay="0"
                      indicator-color="white"
                      :loop="false"
                      @change="
                        index => {
                          return onChange(index, elem);
                        }
                      "
                    >
                      <van-swipe-item
                        v-for="(item, index) in elem"
                        :key="index"
                        :style="
                          item.courseName
                            ? 'background-color:' + calcColor(index, 0,num,item.courseName,item.jx0404id)
                            : ''
                        "
                      >
                        <span v-show="item.courseName"
                          >{{ item.courseName }} - {{ item.teacherName }} @
                          {{ item.classroomName }}
                          <span v-if="schoolCode == '14345' || schoolCode == '12989'"
                            >-{{ item.ktmc }}</span
                          >
                          <span v-if="schoolCode == '10488'"
                            > -第{{ item.kkzc }}周</span
                          >
                        </span>
                        <span v-show="!item.courseName"></span>
                        <p
                          v-if="item.buttonCode != 0"
                          v-text="
                            item.buttonCode == 2 ? '进入课堂' : '创建课堂'
                          "
                        ></p>
                      </van-swipe-item>
                      <template #indicator>
                        <div v-if="elem.length > 1" class="custom-indicator">
                          {{ elem.current + 1 }}/{{ elem.length }}
                        </div>
                      </template>
                    </van-swipe>
                  </li>
                </template>
              </template>
            </ul>
          </div>
          <!-- 周五 -->
          <div class="course-form" id="Friday">
            <ul class="myul">
              <template v-for="(list, active) in FridayList">
                <template v-for="(elem, num) in list">
                  <li
                    ref="ranText"
                    :style="
                      elem[0].courseName
                        ? 'top:' +
                          calcOpt(elem[0].weekNoteDetail, 0) +
                          'height:' +
                          calcOpt(elem[0].weekNoteDetail, 1)
                        : ''
                    "
                    @click="courseDetail(elem)"
                    :key="active + num"
                  >
                    <van-swipe
                      class="my-swipe"
                      :autoplay="0"
                      indicator-color="white"
                      :loop="false"
                      @change="
                        index => {
                          return onChange(index, elem);
                        }
                      "
                    >
                      <van-swipe-item
                        v-for="(item, index) in elem"
                        :key="index"
                        :style="
                          item.courseName
                            ? 'background-color:' + calcColor(index, 1,num,item.courseName,item.jx0404id)
                            : ''
                        "
                      >
                        <span v-show="item.courseName"
                          >{{ item.courseName }} - {{ item.teacherName }} @
                          {{ item.classroomName }}
                          <span v-if="schoolCode == '14345' || schoolCode == '12989'"
                            >-{{ item.ktmc }}</span
                          >
                          <span v-if="schoolCode == '10488'"
                            > -第{{ item.kkzc }}周</span
                          >
                        </span>
                        <span v-show="!item.courseName"></span>
                        <p
                          v-if="item.buttonCode != 0"
                          v-text="
                            item.buttonCode == 2 ? '进入课堂' : '创建课堂'
                          "
                        ></p>
                      </van-swipe-item>
                      <template #indicator>
                        <div v-if="elem.length > 1" class="custom-indicator">
                          {{ elem.current + 1 }}/{{ elem.length }}
                        </div>
                      </template>
                    </van-swipe>
                  </li>
                </template>
              </template>
            </ul>
          </div>
          <!-- 周六 -->
          <div class="course-form" id="Saturday">
            <ul class="myul">
              <template v-for="(list, active) in SaturdayList">
                <template v-for="(elem, num) in list">
                  <li
                    ref="ranText"
                    :style="
                      elem[0].courseName
                        ? 'top:' +
                          calcOpt(elem[0].weekNoteDetail, 0) +
                          'height:' +
                          calcOpt(elem[0].weekNoteDetail, 1)
                        : ''
                    "
                    @click="courseDetail(elem)"
                    :key="active + num"
                  >
                    <van-swipe
                      class="my-swipe"
                      :autoplay="0"
                      indicator-color="white"
                      :loop="false"
                      @change="
                        index => {
                          return onChange(index, elem);
                        }
                      "
                    >
                      <van-swipe-item
                        v-for="(item, index) in elem"
                        :key="index"
                        :style="
                          item.courseName
                            ? 'background-color:' + calcColor(index, 0,num,item.courseName,item.jx0404id)
                            : ''
                        "
                      >
                        <span v-show="item.courseName"
                          >{{ item.courseName }} - {{ item.teacherName }} @
                          {{ item.classroomName }}
                          <span v-if="schoolCode == '14345' || schoolCode == '12989'"
                            >-{{ item.ktmc }}</span
                          >
                          <span v-if="schoolCode == '10488'"
                            > -第{{ item.kkzc }}周</span
                          >
                        </span>
                        <span v-show="!item.courseName"></span>
                        <p
                          v-if="item.buttonCode != 0"
                          v-text="
                            item.buttonCode == 2 ? '进入课堂' : '创建课堂'
                          "
                        ></p>
                      </van-swipe-item>
                      <template #indicator>
                        <div v-if="elem.length > 1" class="custom-indicator">
                          {{ elem.current + 1 }}/{{ elem.length }}
                        </div>
                      </template>
                    </van-swipe>
                  </li>
                </template>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="footerparndiv" v-if="schoolCode == '14621'||schoolCode == '10488'">
      <div class="bottomleftdiv"><p>备注</p></div>
      <div class="bottomrightdiv">
        <p>{{ BottomDiv }}</p>
      </div>
    </div>
    <div class="xskcxsPopup" v-show="xskcShow" v-if=" schoolCode == '10045'">
      <div style="margin-bottom: 10px;"> 
        <span class="xskcxsPopuptitle">线上课程</span>
        <span class="xskcxsPopupxx" @click="xskcxsDetailPopup=true;">详细 ></span>
      </div>
      <div>
        {{ xskcInfo }}
      </div>
    </div>
    <div v-if=" schoolCode == '10537'" class="van-popup-parm">
      <div class="popup van-popup van-popup--bottom xskcxsPopup_bz_button" @click="to_hsbz"  >
        <span v-if="bz_show">></span>
        <span v-else><</span>
      </div>
      <div class="popup van-popup van-popup--bottom xskcxsPopup_bz"  v-if="bz_show" >
      <div > 
        <span class="xskcxsPopuptitle">备注</span>
      </div>
      <div class="xskcxsPopup_bz_context" >
        {{BottomDiv_bz}}
      </div>
    </div>
    </div>
   
    <div  class="xskcpopup" v-show="xskcxsDetailPopup" v-if=" schoolCode == '10045'"> 
      <div class="popup-title">
         <span>线上课程</span>
      </div>
      <div class="popup-context">
        <span v-html="xskcInfoDetail"></span>
      </div>
      <div class="popup-float">
        <button  @click="xskcxsDetailPopup = false;">
          确定
        </button>
      </div>
    </div>
    </div>
    <van-tabs
      type="line"
      v-model="active"
      animated
      color="#0088F8"
      v-if="schoolCode === '10294'"
    >
    <van-tab title="课表课程">
    <div class="timetable_top1">
      <van-field
        readonly
        clickable
        placeholder="周次"
        v-model="curWeek"
        @click="
          showPicker = true;
          change = false;
        "
      />
      <i class="week-arrow"></i>
      <van-field  v-if="this.schoolCode == 10894" style="margin-left: 15px;font-size: 12px;width: 60px;" v-model="jgxm"  placeholder="按老师查询"  @input="jgxmcx" />
    
      
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @cancel="showPicker = false"
          @confirm="onConfirm"
          :item-height="35"
          :default-index="defaultIndex"
        />
      </van-popup>

      <van-popup v-model="showJgxx" position="bottom">
        <van-picker
          show-toolbar
          :columns="jgxxColumns"
          @cancel="showJgxx = false"
          @confirm="onJgxxConfirm"
          :item-height="35"
          :default-index="defaultIndex"
        />
      </van-popup>

      <div class="time-right">
        <!-- 时间模式 -->
        <van-field
          readonly
          clickable
          placeholder=""
          v-model="timeMode"
          @click="modePicker = true"
        />
        <i class="week-arrow"></i>
        <van-popup v-model="modePicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="modeColumns"
            @cancel="modePicker = false"
            @confirm="modeConfirm"
            :item-height="35"
            :default-index="defaultIndex1"
          />
        </van-popup>
        <div class="currentTime" @click="fn1(nowzc, undefined)">今</div>
      </div>
    </div>
    <div class="timetable_list">
      <div class="period" style="margin-bottom: 70px">
        <div
          :style="schoolCode == '10762' ? 'width:62px' : ''"
          v-if="this.schoolCode == 10759 && this.weekday == 0"
        >
          节<br />次
        </div>
        <div :style="schoolCode == '10762' ? 'width:62px' : ''" v-else>
          {{ this.weekday }}<br />月
        </div>
        <ul v-if="schoolCode == '10762'">
          <li
            style="width: 62px;height: 131px;line-height: 131px;"
            v-for="(item, index) in nodeList"
            :key="index"
          >
            {{ item }}
          </li>
        </ul>
        <ul v-else>
          <li v-for="(item, index) in nodeList" :key="index">
            {{ item.nodeNumber }}
          </li>
          <li v-if=" schoolCode == '10045'"></li>
          <li v-if=" schoolCode == '10045'"></li>
        </ul>
      </div>
      <div class="table-right">
        <div class="week-nav">
          <ul>
            <li
              :style="
                curDay == '星期' + item.xqmc && nowzc == item.zc
                  ? 'background-color:#12DDD6'
                  : ''
              "
              v-for="(item, index) in dateWeekList"
              :key="index"
            >
              <span>周{{ item.xqmc }}</span>
              <p v-if="item.zc != 'all'">{{ dateSub(item.mxrq) }}</p>
            </li>
          </ul>
        </div>
        <div class="course-content">
          <!-- 周日 -->
          <div class="course-form" id="Sunday">
            <ul class="myul">
              <template v-for="(list, active) in SundayList">
                <template v-for="(elem, num) in list">
                  <li
                    ref="ranText"
                    :style="
                      elem[0].courseName
                        ? 'top:' +
                          calcOpt(elem[0].weekNoteDetail, 0) +
                          'height:' +
                          calcOpt(elem[0].weekNoteDetail, 1)
                        : ''
                    "
                    @click="courseDetail(elem)"
                    :key="active + num"
                  >
                    <van-swipe
                      class="my-swipe"
                      :autoplay="0"
                      indicator-color="white"
                      :loop="false"
                      @change="
                        index => {
                          return onChange(index, elem);
                        }
                      "
                    >
                      <van-swipe-item
                        v-for="(item, index) in elem"
                        :key="index"
                        :style="
                          item.courseName
                            ? 'background-color:' + calcColor(index, 0,num,item.courseName,item.jx0404id)
                            : ''
                        "
                      >
                        <span v-show="item.courseName"
                          >{{ item.courseName }} - {{ item.teacherName }} @
                          {{ item.classroomName }}
                          <span v-if="schoolCode == '14345' || schoolCode == '12989'"
                            >-{{ item.ktmc }}</span
                          >
                          <span v-if="schoolCode == '10488'"
                            > -第{{ item.kkzc }}周</span
                          >
                        </span>
                        <span v-show="!item.courseName"></span>
                        <p
                          v-if="item.buttonCode != 0"
                          v-text="
                            item.buttonCode == 2 ? '进入课堂' : '创建课堂'
                          "
                        ></p>
                      </van-swipe-item>
                      <template #indicator>
                        <div v-if="elem.length > 1" class="custom-indicator">
                          {{ elem.current + 1 }}/{{ elem.length }}
                        </div>
                      </template>
                    </van-swipe>
                  </li>
                </template>
              </template>
            </ul>
          </div>
          <!-- 周一 -->
          <div class="course-form" id="monday">
            <ul class="myul">
              <template v-for="(list, active) in mondayList">
                <template v-for="(elem, num) in list">
                  <li
                    ref="ranText"
                    :style="
                      elem[0].courseName
                        ? 'top:' +
                          calcOpt(elem[0].weekNoteDetail, 0) +
                          'height:' +
                          calcOpt(elem[0].weekNoteDetail, 1)
                        : ''
                    "
                    @click="courseDetail(elem)"
                    :key="active + num"
                  >
                    <van-swipe
                      class="my-swipe"
                      :autoplay="0"
                      indicator-color="white"
                      :loop="false"
                      @change="
                        index => {
                          return onChange(index, elem);
                        }
                      "
                    >
                      <van-swipe-item
                        v-for="(item, index) in elem"
                        :key="index"
                        :style="
                          item.courseName
                            ? 'background-color:' + calcColor(index, 1,num,item.courseName,item.jx0404id)
                            : ''
                        "
                      >
                        <span v-show="item.courseName"
                          >{{ item.courseName }} - {{ item.teacherName }} @
                          {{ item.classroomName }}
                          <span v-if="schoolCode == '14345' || schoolCode == '12989'"
                            >-{{ item.ktmc }}</span
                          >
                          <span v-if="schoolCode == '10488'"
                            > -第{{ item.kkzc }}周</span
                          >
                        </span>
                        <span v-show="!item.courseName"></span>
                        <p
                          v-if="item.buttonCode != 0"
                          v-text="
                            item.buttonCode == 2 ? '进入课堂' : '创建课堂'
                          "
                        ></p>
                      </van-swipe-item>
                      <template #indicator>
                        <div v-if="elem.length > 1" class="custom-indicator">
                          {{ elem.current + 1 }}/{{ elem.length }}
                        </div>
                      </template>
                    </van-swipe>
                  </li>
                </template>
              </template>
            </ul>
          </div>
          <!-- 周二 -->
          <div class="course-form" id="Tuesday">
            <ul class="myul">
              <template v-for="(list, active) in TuesdayList">
                <template v-for="(elem, num) in list">
                  <li
                    ref="ranText"
                    :style="
                      elem[0].courseName
                        ? 'top:' +
                          calcOpt(elem[0].weekNoteDetail, 0) +
                          'height:' +
                          calcOpt(elem[0].weekNoteDetail, 1)
                        : ''
                    "
                    @click="courseDetail(elem)"
                    :key="active + num"
                  >
                    <van-swipe
                      class="my-swipe"
                      :autoplay="0"
                      indicator-color="white"
                      :loop="false"
                      @change="
                        index => {
                          return onChange(index, elem);
                        }
                      "
                    >
                      <van-swipe-item
                        v-for="(item, index) in elem"
                        :key="index"
                        :style="
                          item.courseName
                            ? 'background-color:' + calcColor(index, 0,num,item.courseName,item.jx0404id)
                            : ''
                        "
                      >
                        <span v-show="item.courseName"
                          >{{ item.courseName }} - {{ item.teacherName }} @
                          {{ item.classroomName }}
                          <span v-if="schoolCode == '14345' || schoolCode == '12989'"
                            >-{{ item.ktmc }}</span
                          >
                          <span v-if="schoolCode == '10488'"
                            > -第{{ item.kkzc }}周</span
                          >
                        </span>
                        <span v-show="!item.courseName"></span>
                        <p
                          v-if="item.buttonCode != 0"
                          v-text="
                            item.buttonCode == 2 ? '进入课堂' : '创建课堂'
                          "
                        ></p>
                      </van-swipe-item>
                      <template #indicator>
                        <div v-if="elem.length > 1" class="custom-indicator">
                          {{ elem.current + 1 }}/{{ elem.length }}
                        </div>
                      </template>
                    </van-swipe>
                  </li>
                </template>
              </template>
            </ul>
          </div>
          <!-- 周三 -->
          <div class="course-form" id="Wednesday">
            <ul class="myul">
              <template v-for="(list, active) in WednesdayList">
                <template v-for="(elem, num) in list">
                  <li
                    ref="ranText"
                    :style="
                      elem[0].courseName
                        ? 'top:' +
                          calcOpt(elem[0].weekNoteDetail, 0) +
                          'height:' +
                          calcOpt(elem[0].weekNoteDetail, 1)
                        : ''
                    "
                    @click="courseDetail(elem)"
                    :key="active + num"
                  >
                    <van-swipe
                      class="my-swipe"
                      :autoplay="0"
                      indicator-color="white"
                      :loop="false"
                      @change="
                        index => {
                          return onChange(index, elem);
                        }
                      "
                    >
                      <van-swipe-item
                        v-for="(item, index) in elem"
                        :key="index"
                        :style="
                          item.courseName
                            ? 'background-color:' + calcColor(index, 1,num,item.courseName,item.jx0404id)
                            : ''
                        "
                      >
                        <span v-show="item.courseName"
                          >{{ item.courseName }} - {{ item.teacherName }} @
                          {{ item.classroomName }}
                          <span v-if="schoolCode == '14345' || schoolCode == '12989'"
                            >-{{ item.ktmc }}</span
                          >
                          <span v-if="schoolCode == '10488'"
                            > -第{{ item.kkzc }}周</span
                          >
                        </span>
                        <span v-show="!item.courseName"></span>
                        <p
                          v-if="item.buttonCode != 0"
                          v-text="
                            item.buttonCode == 2 ? '进入课堂' : '创建课堂'
                          "
                        ></p>
                      </van-swipe-item>
                      <template #indicator>
                        <div v-if="elem.length > 1" class="custom-indicator">
                          {{ elem.current + 1 }}/{{ elem.length }}
                        </div>
                      </template>
                    </van-swipe>
                  </li>
                </template>
              </template>
            </ul>
          </div>
          <!-- 周四 -->
          <div class="course-form" id="Thursday">
            <ul class="myul">
              <template v-for="(list, active) in ThursdayList">
                <template v-for="(elem, num) in list">
                  <li
                    ref="ranText"
                    :style="
                      elem[0].courseName
                        ? 'top:' +
                          calcOpt(elem[0].weekNoteDetail, 0) +
                          'height:' +
                          calcOpt(elem[0].weekNoteDetail, 1)
                        : ''
                    "
                    @click="courseDetail(elem)"
                    :key="active + num"
                  >
                    <van-swipe
                      class="my-swipe"
                      :autoplay="0"
                      indicator-color="white"
                      :loop="false"
                      @change="
                        index => {
                          return onChange(index, elem);
                        }
                      "
                    >
                      <van-swipe-item
                        v-for="(item, index) in elem"
                        :key="index"
                        :style="
                          item.courseName
                            ? 'background-color:' + calcColor(index, 0,num,item.courseName,item.jx0404id)
                            : ''
                        "
                      >
                        <span v-show="item.courseName"
                          >{{ item.courseName }} - {{ item.teacherName }} @
                          {{ item.classroomName }}
                          <span v-if="schoolCode == '14345' || schoolCode == '12989'"
                            >-{{ item.ktmc }}</span
                          >
                          <span v-if="schoolCode == '10488'"
                            > -第{{ item.kkzc }}周</span
                          >
                        </span>
                        <span v-show="!item.courseName"></span>
                        <p
                          v-if="item.buttonCode != 0"
                          v-text="
                            item.buttonCode == 2 ? '进入课堂' : '创建课堂'
                          "
                        ></p>
                      </van-swipe-item>
                      <template #indicator>
                        <div v-if="elem.length > 1" class="custom-indicator">
                          {{ elem.current + 1 }}/{{ elem.length }}
                        </div>
                      </template>
                    </van-swipe>
                  </li>
                </template>
              </template>
            </ul>
          </div>
          <!-- 周五 -->
          <div class="course-form" id="Friday">
            <ul class="myul">
              <template v-for="(list, active) in FridayList">
                <template v-for="(elem, num) in list">
                  <li
                    ref="ranText"
                    :style="
                      elem[0].courseName
                        ? 'top:' +
                          calcOpt(elem[0].weekNoteDetail, 0) +
                          'height:' +
                          calcOpt(elem[0].weekNoteDetail, 1)
                        : ''
                    "
                    @click="courseDetail(elem)"
                    :key="active + num"
                  >
                    <van-swipe
                      class="my-swipe"
                      :autoplay="0"
                      indicator-color="white"
                      :loop="false"
                      @change="
                        index => {
                          return onChange(index, elem);
                        }
                      "
                    >
                      <van-swipe-item
                        v-for="(item, index) in elem"
                        :key="index"
                        :style="
                          item.courseName
                            ? 'background-color:' + calcColor(index, 1,num,item.courseName,item.jx0404id)
                            : ''
                        "
                      >
                        <span v-show="item.courseName"
                          >{{ item.courseName }} - {{ item.teacherName }} @
                          {{ item.classroomName }}
                          <span v-if="schoolCode == '14345' || schoolCode == '12989'"
                            >-{{ item.ktmc }}</span
                          >
                          <span v-if="schoolCode == '10488'"
                            > -第{{ item.kkzc }}周</span
                          >
                        </span>
                        <span v-show="!item.courseName"></span>
                        <p
                          v-if="item.buttonCode != 0"
                          v-text="
                            item.buttonCode == 2 ? '进入课堂' : '创建课堂'
                          "
                        ></p>
                      </van-swipe-item>
                      <template #indicator>
                        <div v-if="elem.length > 1" class="custom-indicator">
                          {{ elem.current + 1 }}/{{ elem.length }}
                        </div>
                      </template>
                    </van-swipe>
                  </li>
                </template>
              </template>
            </ul>
          </div>
          <!-- 周六 -->
          <div class="course-form" id="Saturday">
            <ul class="myul">
              <template v-for="(list, active) in SaturdayList">
                <template v-for="(elem, num) in list">
                  <li
                    ref="ranText"
                    :style="
                      elem[0].courseName
                        ? 'top:' +
                          calcOpt(elem[0].weekNoteDetail, 0) +
                          'height:' +
                          calcOpt(elem[0].weekNoteDetail, 1)
                        : ''
                    "
                    @click="courseDetail(elem)"
                    :key="active + num"
                  >
                    <van-swipe
                      class="my-swipe"
                      :autoplay="0"
                      indicator-color="white"
                      :loop="false"
                      @change="
                        index => {
                          return onChange(index, elem);
                        }
                      "
                    >
                      <van-swipe-item
                        v-for="(item, index) in elem"
                        :key="index"
                        :style="
                          item.courseName
                            ? 'background-color:' + calcColor(index, 0,num,item.courseName,item.jx0404id)
                            : ''
                        "
                      >
                        <span v-show="item.courseName"
                          >{{ item.courseName }} - {{ item.teacherName }} @
                          {{ item.classroomName }}
                          <span v-if="schoolCode == '14345' || schoolCode == '12989'"
                            >-{{ item.ktmc }}</span
                          >
                          <span v-if="schoolCode == '10488'"
                            > -第{{ item.kkzc }}周</span
                          >
                        </span>
                        <span v-show="!item.courseName"></span>
                        <p
                          v-if="item.buttonCode != 0"
                          v-text="
                            item.buttonCode == 2 ? '进入课堂' : '创建课堂'
                          "
                        ></p>
                      </van-swipe-item>
                      <template #indicator>
                        <div v-if="elem.length > 1" class="custom-indicator">
                          {{ elem.current + 1 }}/{{ elem.length }}
                        </div>
                      </template>
                    </van-swipe>
                  </li>
                </template>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="footerparndiv" v-if="schoolCode == '14621'||schoolCode == '10488'">
      <div class="bottomleftdiv"><p>备注</p></div>
      <div class="bottomrightdiv">
        <p>{{ BottomDiv }}</p>
      </div>
    </div>
    <div class="xskcxsPopup" v-show="xskcShow" v-if=" schoolCode == '10045'">
      <div style="margin-bottom: 10px;"> 
        <span class="xskcxsPopuptitle">线上课程</span>
        <span class="xskcxsPopupxx" @click="xskcxsDetailPopup=true;">详细 ></span>
      </div>
      <div>
        {{ xskcInfo }}
      </div>
    </div>
    <div  class="xskcpopup" v-show="xskcxsDetailPopup" v-if=" schoolCode == '10045'"> 
      <div class="popup-title">
         <span>线上课程</span>
      </div>
      <div class="popup-context">
        <span v-html="xskcInfoDetail"></span>
      </div>
      <div class="popup-float">
        <button  @click="xskcxsDetailPopup = false;">
          确定
        </button>
      </div>
    </div>
    </van-tab>
    <van-tab title="无课表课程">
      <el-table :data="wkbkcList" :row-class-name="tableRowClassName1">
        <el-table-column type="index" label="序号" width="100"></el-table-column>
      	<el-table-column prop="kch" label="课程编号" width="160" sortable></el-table-column>
      	<el-table-column prop="kxhnew" label="课序号" width="125" sortable></el-table-column>
        <el-table-column prop="kcmc" label="课程名称" width="125" sortable ></el-table-column>
        <el-table-column prop="ktmc" label="上课班级" width="125" sortable ></el-table-column>
        <el-table-column prop="jg0101mc" label="授课教师" width="125" sortable ></el-table-column>
        <el-table-column prop="kcsx" label="课程属性" width="125" sortable ></el-table-column>
      </el-table>
    </van-tab>
    <van-tab title="教学任务">
      <el-table :data="jxrwList" :row-class-name="tableRowClassName1">
        <el-table-column type="index" label="序号" width="100"></el-table-column>
      	<el-table-column prop="kch" label="课程编号" width="160" sortable></el-table-column>
      	<el-table-column prop="kxhnew" label="课序号" width="125" sortable></el-table-column>
        <el-table-column prop="kcmc" label="课程名称" width="125" sortable ></el-table-column>
        <el-table-column prop="ktmc" label="上课班级" width="125" sortable ></el-table-column>
        <el-table-column prop="jg0101mc" label="授课教师" width="125" sortable ></el-table-column>
        <el-table-column prop="kcsx" label="课程属性" width="125" sortable ></el-table-column>
      </el-table>
    </van-tab>
    </van-tabs>
    <van-popup v-model="popShow" class="popup">
      <h2>
        <i class="close-pop" @click="popShow = false"></i>
      </h2>
      <div
        class="popup-content"
        v-for="(item, index) in this.popList"
        :key="index"
      >
        <p v-if=" schoolCode == '10045'">
          课程编号：<span>{{ item.kcbh }}</span>
        </p>
        <p v-if=" schoolCode == '10045'">
          课序号：<span>{{ item.kxh }}</span>
        </p>
        <p>
          课程名称：<span>{{ item.courseName }}</span>
        </p>
        <p v-if=" schoolCode == '10045'">
          时间：<span>{{ infoWeek }}</span>
        </p>
        <p v-if=" schoolCode == '12977'">
          时间：<span>{{item.kkzc}}周   {{ infoWeek }}</span>
        </p>
        <p v-else>
          时间：<span>{{ infoWeek }} ,{{ item.weekNoteDetail }}</span>
        </p>
        <p>
          地点：<span>{{ item.classroomName }}</span>
        </p>
        <p>
          教师：<span>{{ item.teacherName }}</span>
        </p>
        <p v-if="schoolCode == '10008' || schoolCode == '10045'">
          教学楼：<span>{{ item.buildingName }}</span>
        </p>
        <p v-if="schoolCode == '14345' || schoolCode == '12343' || schoolCode == '12989' || schoolCode == '12977' ||needClassName=='1'">
          班级：<span>{{ item.ktmc }}</span>
        </p>
        <p v-if="needClassRoomNub=='1'">
          教室编号：<span>{{ item.classroomNub }}</span>
        </p>
        <p v-if="schoolCode == '10011'">
          备注：<span>{{ item.kbbz }}</span>
        </p>
        <p v-if="schoolCode == '10759'">
          选课人数：<span class="span_peo" @click="toSeeStudents(item)">{{
            item.xkrs
          }}</span>
        </p>
        <p v-if="schoolCode == '10759'">
          教学备注：<span>{{ item.jxbz }}</span>
        </p>
        <p v-if="item.meetingData">
          课堂号：<span>{{ item.meetingData.meetingNumber }}</span>
        </p>
        <p v-if="item.meetingData">
          主持课堂密码：<span>{{ item.meetingData.controlPassword }}</span>
        </p>
        <p v-if="item.meetingData">
          课堂密码：<span>{{ item.meetingData.password }}</span>
        </p>
        <p v-if="schoolCode == '10762'">
          分组名：<span>{{ item.fzmc }}</span>
        </p>
        <p v-if="schoolCode == '11449'">
          课程时间：<span>{{ item.startTime }}~{{ item.endTIme }}</span>
        </p>

        <p v-if="schoolCode == '12900'">
          考核方式：<span>{{ item.khfs }}</span>
        </p>
        <p v-if="schoolCode == '10488'">
          教学周:<span>第{{ item.kkzc }}周</span>
        </p>
      </div>

      <!-- <p v-if="this.popList.buttonCode == 2" class="link-item">课堂链接：<span>{{this.popList.meetingData.shareUrl ? this.popList.meetingData.shareUrl : '暂未开设云课堂'}}</span></p> -->
      <button @click="checkLive(popList)">
        {{
          this.buttonCodeFlag == "1"
            ? "创建课堂"
            : this.buttonCodeFlag == "0"
            ? "确定"
            : "进入课堂"
        }}
      </button>
    </van-popup>

    <van-popup v-model="popShow_student" class="popup_student">
      <h2>
        <i class="close-pop" @click="popShow_student = false"></i>学生名单
      </h2>
      <div class="student-tittle-div">
        <ul class="ul-student">
          <li class="li-student">姓名</li>
          <li class="li-student">学号</li>
          <li class="li-student">班级</li>
        </ul>
      </div>

      <div
        class="student-context-div "
        v-for="(item, index) in studentsList"
        :key="index"
      >
        <ul v-if="index % 2 == 0" class="ul-student-context div-backclor1">
          <li class="li-student-context ">{{ item.xm }}</li>
          <li class="li-student-context">{{ item.xh }}</li>
          <li class="li-student-context">{{ item.bj }}</li>
        </ul>
        <ul v-if="index % 2 != 0" class="ul-student-context div-backclor2">
          <li class="li-student-context ">{{ item.xm }}</li>
          <li class="li-student-context">{{ item.xh }}</li>
          <li class="li-student-context">{{ item.bj }}</li>
        </ul>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Api } from "../../../utils/axios";
export default {
  data() {
    return {
      active: 0,
      wkbkcList:[],
      jxrwList:[],
        isInJxzl:"0",
      BottomDiv: "",
      BottomDiv_bz:'',
      schoolCode: "",
      casLogin: sessionStorage.getItem("casLogin"),
      isAllow: "",
      timetable: [],
      random: "",
      random1: "",
      random2: "",
      random3: "",
      random4: "",
      random5: "",
      random6: "",
      infoWeek: "",
      popShow: false,
      popShow_student: false,
      popList: [],

      defaultIndex: 0,
      defaultIndex1: 0,
      curWeek: "",
      timeMode: "",
      showPicker: false,
      modePicker: false,
      modeColumns: [],
      modeIdColumns: [],
      timeModeId: "",
      columns: [
        {
          values: [],
          className: "column1"
        }
      ],
      zcList: [],
      xnxqidArr:[],
      zc: "",
      nowzc: "",
      curDay: "",
      allCourseList: [],
      mondayList: [],
      TuesdayList: [],
      WednesdayList: [],
      ThursdayList: [],
      FridayList: [],
      SaturdayList: [],
      SundayList: [],
      nodeList: [],
      weekday: "",
      isShow: true,
      needClassName:false,
      needClassRoomNub:false,
      arr1: [
        { a: "01" },
        { a: "02" },
        { a: "03" },
        { a: "04" },
        { a: "05" },
        { a: "06" },
        { a: "07" },
        { a: "08" },
        { a: "09" },
        { a: "10" },
        { a: "11" },
        { a: "12" }
      ],
      arr2: [
        { a: "01" },
        { a: "02" },
        { a: "03" },
        { a: "04" },
        { a: "05" },
        { a: "06" },
        { a: "07" },
        { a: "08" },
        { a: "09" },
        { a: "10" },
        { a: "11" },
        { a: "12" }
      ],
      arr3: [
        { a: "01" },
        { a: "02" },
        { a: "03" },
        { a: "04" },
        { a: "05" },
        { a: "06" },
        { a: "07" },
        { a: "08" },
        { a: "09" },
        { a: "10" },
        { a: "11" },
        { a: "12" }
      ],
      arr4: [
        { a: "01" },
        { a: "02" },
        { a: "03" },
        { a: "04" },
        { a: "05" },
        { a: "06" },
        { a: "07" },
        { a: "08" },
        { a: "09" },
        { a: "10" },
        { a: "11" },
        { a: "12" }
      ],
      arr5: [
        { a: "01" },
        { a: "02" },
        { a: "03" },
        { a: "04" },
        { a: "05" },
        { a: "06" },
        { a: "07" },
        { a: "08" },
        { a: "09" },
        { a: "10" },
        { a: "11" },
        { a: "12" }
      ],
      arr11: [
        { a: "01" },
        { a: "02" },
        { a: "03" },
        { a: "04" },
        { a: "05" },
        { a: "06" },
        { a: "07" },
        { a: "08" },
        { a: "09" },
        { a: "10" },
        { a: "11" },
        { a: "12" }
      ],
      arr13: [
        { a: "01" },
        { a: "02" },
        { a: "03" },
        { a: "04" },
        { a: "05" },
        { a: "06" },
        { a: "07" },
        { a: "08" },
        { a: "09" },
        { a: "10" },
        { a: "11" },
        { a: "12" }
      ],
      arr6: [
        { a: "02" },
        { a: "04" },
        { a: "06" },
        { a: "08" },
        { a: "10" },
        { a: "12" }
      ],
      arr7: [
        { a: "02" },
        { a: "04" },
        { a: "06" },
        { a: "08" },
        { a: "10" },
        { a: "12" }
      ],
      arr8: [
        { a: "02" },
        { a: "04" },
        { a: "06" },
        { a: "08" },
        { a: "10" },
        { a: "12" }
      ],
      arr9: [
        { a: "02" },
        { a: "04" },
        { a: "06" },
        { a: "08" },
        { a: "10" },
        { a: "12" }
      ],
      arr10: [
        { a: "02" },
        { a: "04" },
        { a: "06" },
        { a: "08" },
        { a: "10" },
        { a: "12" }
      ],
      arr12: [
        { a: "02" },
        { a: "04" },
        { a: "06" },
        { a: "08" },
        { a: "10" },
        { a: "12" }
      ],
      arr14: [
        { a: "02" },
        { a: "04" },
        { a: "06" },
        { a: "08" },
        { a: "10" },
        { a: "12" }
      ],
      dateWeekList: [],
      colorList: ["#FF8282", "#EE7BFF", "#FFBB79", "#FF87B3", "#86B5FF","#865FC1","#00C998","#5E73FF","#FFC327","#00C897","#FF8080"],
      colorList1: [
        "rgba(118,107,255,.7)",
        "#757DA3",
        "rgba(255,84,147,.4)",
        "#B3B9D0",
        "rgba(95,222,255,.7)"
      ],
      colorMap: new Map,
      colorindex :-1,
      updateUrl: "",
      change: true,
      studentsList: [],
      buttonCodeFlag:'0',
      jgxxColumns: [],
      jgxm:'',
      jgid:'',
      timer:'',
      showJgxx:false,
      xskcShow:true,
      xskcInfo:'',
      xskcInfoDetail:'',
      xskcxsDetailPopup: false,
      bz_show:true,
    };
  },
  methods: {
    hiddenXskc(){
      if(this.schoolCode == '10045'){
        this.xskcShow = false;  
        clearTimeout(this.timer)
        this.timer = setTimeout(this.ScrollEnd,500);
      }
    },
    ScrollEnd(){
      this.xskcShow = true;
    },
    async jgxmcx(e){
      if(e != null && e != ''){
        this.showJgxx = true;
        const res = await Api.getJgxx({
          jsmc: e,
        });
        this.jgxxColumns = res.data.map(item => {
          return {
            text: item.xm,
            value: item.jgh
          };
        });
      }else{
        this.showJgxx = false;
        this.jgxxColumns=[];
      }
    },
    async onJgxxConfirm(value, index){
      this.change = true;
      this.allCourseList = [];
      this.mondayList = [];
      this.TuesdayList = [];
      this.WednesdayList = [];
      this.ThursdayList = [];
      this.FridayList = [];
      this.SaturdayList = [];
      this.SundayList = [];

      let mondayList = [];
      let TuesdayList = [];
      let WednesdayList = [];
      let ThursdayList = [];
      let FridayList = [];
      let SaturdayList = [];
      let SundayList = [];
      this.showJgxx = false;
      this.jgxm = value.text;
      this.jgid = value.value;
      const params = {
        week: this.zc,
        kbjcmsid: this.timeModeId,
        jgh:this.jgid
      };
      const res = await Api.teachCourseSchedule(params);
      if(this.schoolCode === '10294'){
        this.wkbkcList = res.wkbkcList
        this.jxrwList = res.jxrwList
      }
      if (res.data.length == 0) {
        this.$toast.fail(res.Msg);
      } else {
        if (res.data[0].courses.length == 0) {
          this.$toast.fail(res.Msg);
        }
        this.dateWeekList = res.data[0].date;
        this.nodeList = res.data[0].nodes;
        this.weekday = Number(res.data[0].date[0].mxrq.substr(5, 2));
        this.curDay = res.data[0].topInfo[0].weekday;
        this.allCourseList = res.data[0].courses;
        for (let i of this.allCourseList) {
          for (let j of i) {
            j.current = 0;
          }
        }
        //周一
        mondayList.push(this.allCourseList[0]);
        //周二
        TuesdayList.push(this.allCourseList[1]);
        //周三
        WednesdayList.push(this.allCourseList[2]);
        //周四
        ThursdayList.push(this.allCourseList[3]);
        //周五
        FridayList.push(this.allCourseList[4]);
        //周六
        SaturdayList.push(this.allCourseList[5]);
        //周日
        SundayList.push(this.allCourseList[6]);
        
        let calStart = res.data[0].date[0].xqmc;
        if (calStart == "日") {
          this.mondayList = mondayList;
          this.TuesdayList = TuesdayList;
          this.WednesdayList = WednesdayList;
          this.ThursdayList = ThursdayList;
          this.FridayList = FridayList;
          this.SaturdayList = SaturdayList;
          this.SundayList = SundayList;
        } else if (calStart == "一") {
          this.mondayList = TuesdayList;
          this.TuesdayList = WednesdayList;
          this.WednesdayList = ThursdayList;
          this.ThursdayList = FridayList;
          this.FridayList = SaturdayList;
          this.SaturdayList = SundayList;
          this.SundayList = mondayList;
        } else if (calStart == "二") {
          this.mondayList = WednesdayList;
          this.TuesdayList = ThursdayList;
          this.WednesdayList = FridayList;
          this.ThursdayList = SaturdayList;
          this.FridayList = SundayList;
          this.SaturdayList = mondayList;
          this.SundayList = TuesdayList;
        } else if (calStart == "三") {
          this.mondayList = ThursdayList;
          this.TuesdayList = FridayList;
          this.WednesdayList = SaturdayList;
          this.ThursdayList = SundayList;
          this.FridayList = mondayList;
          this.SaturdayList = TuesdayList;
          this.SundayList = WednesdayList;
        } else if (calStart == "四") {
          this.mondayList = FridayList;
          this.TuesdayList = SaturdayList;
          this.WednesdayList = SundayList;
          this.ThursdayList = mondayList;
          this.FridayList = TuesdayList;
          this.SaturdayList = WednesdayList;
          this.SundayList = ThursdayList;
        } else if (calStart == "五") {
          this.mondayList = SaturdayList;
          this.TuesdayList = SundayList;
          this.WednesdayList = mondayList;
          this.ThursdayList = TuesdayList;
          this.FridayList = WednesdayList;
          this.SaturdayList = ThursdayList;
          this.SundayList = FridayList;
        } else if (calStart == "六") {
          this.mondayList = SundayList;
          this.TuesdayList = mondayList;
          this.WednesdayList = TuesdayList;
          this.ThursdayList = WednesdayList;
          this.FridayList = ThursdayList;
          this.SaturdayList = FridayList;
          this.SundayList = SaturdayList;
        }
      }
    },
    onChange(index, elem) {
      elem.current = index;
    },
    calcColor(index, type, active,courseName,ktid) {
      if(this.schoolCode==10488){
        courseName = ktid;
      }
      if(!this.colorMap.has(courseName)){
          if(this.colorindex == this.colorList.length-1){
            this.colorindex = -1;
          }
          this.colorindex++;
          this.colorMap.set(courseName,this.colorindex)
        }
        return this.colorList[this.colorMap.get(courseName)];
      index = index + active;
      // let num = parseInt(Math.random()*5)
      let num = Math.abs(index - 2) % 5;
      let num1 = Math.abs(index - 4) % 5;
      if (this.change) {
        if (type == 0) {
          return this.colorList[num];
        } else {
          return this.colorList1[num1];
        }
      }
    },
    modeConfirm(val, index) {
      this.modePicker = false;
      this.timeMode = val;
      this.timeModeId = this.modeIdColumns[index];
      this.fn1(this.zc, this.modeIdColumns[index]);
    },
    async timeModeTap() {
      const res = await Api.getTimeMode();
      if (res.data.length > 0) {
        res.data.forEach((item, index) => {
          if (item.mrms == 1 && this.schoolCode != '10689') {
            this.timeMode = item.kbjcmsmc;
            this.defaultIndex1 = index;
            this.timeModeId = item.kbjcmsid;
          }
          this.modeColumns.push(item.kbjcmsmc);
          this.modeIdColumns.push(item.kbjcmsid);
        });
      }
    },
    async checkLive(e) {
      this.popShow = false;
      if (this.buttonCodeFlag == 2) {
        if (this.isAllow) {
          window.location.href = this.updateUrl;
        } else {
          this.$toast.fail("该门课程暂未开设云课堂");
        }
      } else if (this.buttonCodeFlag == 1) {
        const params = {
          coursePlanId: e.coursePlanId,
          courseName: e.courseName,
          startTime: e.startTime,
          endTIme: e.endTIme,
          peopleNumber: e.peopleNumber
        };
        const res = await Api.teachCreatMeetingV2(params);
        if (res.code == "0") {
          this.$toast.fail(res.Msg);
        } else {
          this.$toast.success(res.Msg);
          this.loadClass();
        }
      }
    },
    async toSeeStudents(data) {
      this.popShow_student = true;
      const params = {
        jx0404id: data.jx0404id
      };
      const res = await Api.getStudentByTD(params);
      this.studentsList = res.data;
    },
    async courseDetail(arr) {
      let xqArr = ["星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期日"];
      let info = arr[0];
      this.change = false;
      switch (info.weekDay) {
        case "1":
          this.infoWeek = "周一";
          break;
        case "2":
          this.infoWeek = "周二";
          break;
        case "3":
          this.infoWeek = "周三";
          break;
        case "4":
          this.infoWeek = "周四";
          break;
        case "5":
          this.infoWeek = "周五";
          break;
        case "6":
          this.infoWeek = "周六";
          break;
        case "7":
          this.infoWeek = "周日";
          break;
        default:
          break;
      }
      this.popShow = true;
      this.popList = arr;
      this.buttonCodeFlag = arr[0].buttonCode;
      if(this.schoolCode == '10045'){
        this.infoWeek = this.infoWeek + "，" + info.jcszsj;
      }else if(this.schoolCode == '12977'){
        this.infoWeek =  xqArr[info.weekDay-1];
        this.infoWeek+="（" ; 
        var jcarr = info.weekNoteDetail.split(',')
        jcarr.forEach((jcitem,index) => {
          this.infoWeek+=jcitem.substr(1, 2) ;
          if(index != jcarr.length -1){
            this.infoWeek+=',';
          }
        })
        this.infoWeek +="小节）" ;
      }
      const params = {
        coursePlanId: info.coursePlanId
      };
      const res = await Api.isYxMeetingV2Api(params);
      this.isAllow = res.data.result;
      if (res.data.result) {
        this.updateUrl = res.data.meetingData.shareUrl;
        this.popList.meetingData = res.data.meetingData;
      }
    },
    dateSub(res) {
      return Number(res.substr(-2, 2));
    },
    calcOpt_10331(jcStr,type){
      let topHgt = 0;
      if(type=='0'){
        let startNb = jcStr.substr(1, 2)
        this.nodeList.forEach((item, index) => {
          if(startNb==item.nodeNumber){
            topHgt = index;
          }
        }); 
      }
      return topHgt;
    },
    calcOpt(val, type) {
      if(this.schoolCode=='10331'){
        //let num = val.substr(1, 2)
        //top
        if (type == 0) {
          let topHgt = this.calcOpt_10331(val,"0");
          return Number(topHgt) * 70 + "px;";
          //height
        } else {
          return ((val.length+1)/4*70-1)+"px";
        }
      }else{
        let num = Number(val.substr(1, 2)) - 1;
      //top
      if (type == 0) {
        return num * 70 + "px;";
        //height
      } else {
        return ((val.length+1)/4*70-1)+"px";
      }
      }
    
    },
    async onConfirm(value, index) {
      this.change = true;
      this.allCourseList = [];
      this.mondayList = [];
      this.TuesdayList = [];
      this.WednesdayList = [];
      this.ThursdayList = [];
      this.FridayList = [];
      this.SaturdayList = [];
      this.SundayList = [];

      let mondayList = [];
      let TuesdayList = [];
      let WednesdayList = [];
      let ThursdayList = [];
      let FridayList = [];
      let SaturdayList = [];
      let SundayList = [];
      this.curWeek = value.toString();

      if(this.schoolCode == "10894"){
        this.zc = this.zcList[index[0]];
      }else{
        this.zc = this.zcList[index];
      }
      
      if (this.schoolCode == "10759"||this.schoolCode == "10488") {
        this.zc = this.zcList[index - 1];
      }
      this.showPicker = false;
      const params = {
        week: this.zc,
        kbjcmsid: this.timeModeId
      };
      if (this.schoolCode == "10008" || this.schoolCode == "10759"||this.schoolCode == "10488") {
        if (this.curWeek === "全部") {
          params.week = "all";
        }
      }
      if(this.schoolCode == "10894"){
        params.jgh  =this.jgid;
        let xnxqid = this.xnxqidArr[index[1]];
        params.xnxqid  = xnxqid;
      }
      
      const res = await Api.teachCourseSchedule(params);
      if(this.schoolCode === '10294'){
        this.wkbkcList = res.wkbkcList
        this.jxrwList = res.jxrwList
      }
      if (res.data.length == 0) {
        this.$toast.fail(res.Msg);
      } else {
        if (res.data[0].courses.length == 0) {
          this.$toast.fail(res.Msg);
        }
        this.dateWeekList = res.data[0].date;
        this.nodeList = res.data[0].nodes;
        this.weekday = Number(res.data[0].date[0].mxrq.substr(5, 2));
        this.curDay = res.data[0].topInfo[0].weekday;
        this.allCourseList = res.data[0].courses;
        for (let i of this.allCourseList) {
          for (let j of i) {
            j.current = 0;
          }
        }
        //周一
        mondayList.push(this.allCourseList[0]);
        //周二
        TuesdayList.push(this.allCourseList[1]);
        //周三
        WednesdayList.push(this.allCourseList[2]);
        //周四
        ThursdayList.push(this.allCourseList[3]);
        //周五
        FridayList.push(this.allCourseList[4]);
        //周六
        SaturdayList.push(this.allCourseList[5]);
        //周日
        SundayList.push(this.allCourseList[6]);
        
        let calStart = res.data[0].date[0].xqmc;
        if (calStart == "日") {
          this.mondayList = mondayList;
          this.TuesdayList = TuesdayList;
          this.WednesdayList = WednesdayList;
          this.ThursdayList = ThursdayList;
          this.FridayList = FridayList;
          this.SaturdayList = SaturdayList;
          this.SundayList = SundayList;
        } else if (calStart == "一") {
          this.mondayList = TuesdayList;
          this.TuesdayList = WednesdayList;
          this.WednesdayList = ThursdayList;
          this.ThursdayList = FridayList;
          this.FridayList = SaturdayList;
          this.SaturdayList = SundayList;
          this.SundayList = mondayList;
        } else if (calStart == "二") {
          this.mondayList = WednesdayList;
          this.TuesdayList = ThursdayList;
          this.WednesdayList = FridayList;
          this.ThursdayList = SaturdayList;
          this.FridayList = SundayList;
          this.SaturdayList = mondayList;
          this.SundayList = TuesdayList;
        } else if (calStart == "三") {
          this.mondayList = ThursdayList;
          this.TuesdayList = FridayList;
          this.WednesdayList = SaturdayList;
          this.ThursdayList = SundayList;
          this.FridayList = mondayList;
          this.SaturdayList = TuesdayList;
          this.SundayList = WednesdayList;
        } else if (calStart == "四") {
          this.mondayList = FridayList;
          this.TuesdayList = SaturdayList;
          this.WednesdayList = SundayList;
          this.ThursdayList = mondayList;
          this.FridayList = TuesdayList;
          this.SaturdayList = WednesdayList;
          this.SundayList = ThursdayList;
        } else if (calStart == "五") {
          this.mondayList = SaturdayList;
          this.TuesdayList = SundayList;
          this.WednesdayList = mondayList;
          this.ThursdayList = TuesdayList;
          this.FridayList = WednesdayList;
          this.SaturdayList = ThursdayList;
          this.SundayList = FridayList;
        } else if (calStart == "六") {
          this.mondayList = SundayList;
          this.TuesdayList = mondayList;
          this.WednesdayList = TuesdayList;
          this.ThursdayList = WednesdayList;
          this.FridayList = ThursdayList;
          this.SaturdayList = FridayList;
          this.SundayList = SaturdayList;
        }
      }
    },
    async fn1(val, e) {

        if(this.isInJxzl!="1"){
            this.$toast.fail("当前日期不在系统设置的当前学期的教学周历范围内!");
            return;
        }
      this.allCourseList = [];
      this.mondayList = [];
      this.TuesdayList = [];
      this.WednesdayList = [];
      this.ThursdayList = [];
      this.FridayList = [];
      this.SaturdayList = [];
      this.SundayList = [];

      let mondayList = [];
      let TuesdayList = [];
      let WednesdayList = [];
      let ThursdayList = [];
      let FridayList = [];
      let SaturdayList = [];
      let SundayList = [];
      const params = {
        week: val,
        kbjcmsid: e ? e : ""
      };
      if(this.schoolCode == "10894"){
        params.jgh  =this.jgid;
      }
      const res = await Api.teachCourseSchedule(params);
      if(this.schoolCode === '10294'){
        this.wkbkcList = res.wkbkcList
        this.jxrwList = res.jxrwList
      }
      if (res.data.length == 0) {
        this.$toast.fail(res.Msg);
        return;
      } else {
        if (res.data[0].courses && res.data[0].courses.length == 0) {
          this.$toast.fail(res.Msg);
          return;
        }
      }
      this.nodeList = res.data[0].nodes;
      if(val!=''){
        this.curWeek = "第" + val + "周";
      }
    
      this.weekday = res.data[0].topInfo[0].today.slice(5, 7);
      this.curDay = res.data[0].topInfo[0].weekday;
      this.allCourseList = res.data[0].courses;
      this.dateWeekList = res.data[0].date;

      for (let i of this.allCourseList) {
        for (let j of i) {
          j.current = 0;
        }
      }
      //周一
      mondayList.push(this.allCourseList[0]);
      //周二
      TuesdayList.push(this.allCourseList[1]);
      //周三
      WednesdayList.push(this.allCourseList[2]);
      //周四
      ThursdayList.push(this.allCourseList[3]);
      //周五
      FridayList.push(this.allCourseList[4]);
      //周六
      SaturdayList.push(this.allCourseList[5]);
      //周日
      SundayList.push(this.allCourseList[6]);
      let calStart = res.data[0].date[0].xqmc;
      if (calStart == "日") {
        this.mondayList = mondayList;
        this.TuesdayList = TuesdayList;
        this.WednesdayList = WednesdayList;
        this.ThursdayList = ThursdayList;
        this.FridayList = FridayList;
        this.SaturdayList = SaturdayList;
        this.SundayList = SundayList;
      } else if (calStart == "一") {
        this.mondayList = TuesdayList;
        this.TuesdayList = WednesdayList;
        this.WednesdayList = ThursdayList;
        this.ThursdayList = FridayList;
        this.FridayList = SaturdayList;
        this.SaturdayList = SundayList;
        this.SundayList = mondayList;
      } else if (calStart == "二") {
        this.mondayList = WednesdayList;
        this.TuesdayList = ThursdayList;
        this.WednesdayList = FridayList;
        this.ThursdayList = SaturdayList;
        this.FridayList = SundayList;
        this.SaturdayList = mondayList;
        this.SundayList = TuesdayList;
      } else if (calStart == "三") {
        this.mondayList = ThursdayList;
        this.TuesdayList = FridayList;
        this.WednesdayList = SaturdayList;
        this.ThursdayList = SundayList;
        this.FridayList = mondayList;
        this.SaturdayList = TuesdayList;
        this.SundayList = WednesdayList;
      } else if (calStart == "四") {
        this.mondayList = FridayList;
        this.TuesdayList = SaturdayList;
        this.WednesdayList = SundayList;
        this.ThursdayList = mondayList;
        this.FridayList = TuesdayList;
        this.SaturdayList = WednesdayList;
        this.SundayList = ThursdayList;
      } else if (calStart == "五") {
        this.mondayList = SaturdayList;
        this.TuesdayList = SundayList;
        this.WednesdayList = mondayList;
        this.ThursdayList = TuesdayList;
        this.FridayList = WednesdayList;
        this.SaturdayList = ThursdayList;
        this.SundayList = FridayList;
      } else if (calStart == "六") {
        this.mondayList = SundayList;
        this.TuesdayList = mondayList;
        this.WednesdayList = TuesdayList;
        this.ThursdayList = WednesdayList;
        this.FridayList = ThursdayList;
        this.SaturdayList = FridayList;
        this.SundayList = SaturdayList;
      }
    },
    classList2(arr, newArr) {
      for (let i in arr) {
        let abc = arr[i];
        for (let n in newArr) {
          if (newArr[n].a == abc.weekNoteDetail.slice(-2)) {
            newArr[n] = abc;
          }
        }
      }
      return newArr;
    },
    async loadClass() {
      const params = {
        week: ""
      };
      if (this.schoolCode == "10008" || this.schoolCode == "10488" ) {
         params.week = "all";
      }
      if(this.schoolCode == "10894"){
        params.jgh  =this.jgid;
      }
      const res = await Api.teachCourseSchedule(params);
      if(this.schoolCode === '10294'){
        this.wkbkcList = res.wkbkcList
        this.jxrwList = res.jxrwList
      }
      if (this.schoolCode == "10045" ) {
        this.xskcInfo = res.data[0].bzstr;
        this.xskcInfoDetail = res.data[0].bzstrxx;
      }
      if(res.data[0]!=null&&res.data[0].bz!=null){
        this.BottomDiv = res.data[0].bz;
      }
      if(this.schoolCode =='10537'){
        this.BottomDiv_bz = res.kbbz
      }
      if(!this.BottomDiv_bz||this.BottomDiv_bz==''){
        this.bz_show = false;
      }
      if (res.data.length == 0) {
        this.$toast.fail(res.Msg);
        if (res.code == "0") {
          this.$toast.fail(res.Msg);
          setTimeout(() => {
            // this.$router.replace('/homeIndex')
          }, 2000);
        }
      } else {
        this.needClassName = res.needClassName;
        this.needClassRoomNub = res.needClassRoomNub;
        if (res.data[0].courses.length == 0) {
          this.$toast.fail(res.Msg);
        }
        this.nodeList = res.data[0].nodes;
        if (this.schoolCode == "10008"||this.schoolCode == "10488" ) {
          this.curWeek = "全部";
           this.nowzc = res.data[0].topInfo[0].week;
        } else {
          //this.curWeek = "第" + res.data[0].topInfo[0].week + "周";
            this.isInJxzl=res.data[0].topInfo[0].isInJxzl;
            if(this.isInJxzl=="0"){
                this.curWeek = "第1周";
                this.nowzc = '1';
                this.weekday = res.data[0].date[0].mxrq.slice(5, 7);
            }
            if(this.isInJxzl=="1"){
                this.curWeek = "第" + res.data[0].topInfo[0].week + "周";
                this.nowzc = res.data[0].topInfo[0].week;
                this.weekday = res.data[0].topInfo[0].today.slice(5, 7);
            }


          // if(params.week==''){
          //     // this.nowzc = res.data[0].topInfo[0].week;
          //     // this.curWeek = "第" +this.nowzc + "周";
          //
          //   this.curWeek = "第1周";
          //   this.nowzc = '1';
          // }else{
          //   this.curWeek = "第" + params.week + "周";
          //   this.nowzc = res.data[0].topInfo[0].week;
          // }
        }
        this.defaultIndex = Number(res.data[0].topInfo[0].week) - 1;
        this.curDay = res.data[0].topInfo[0].weekday;
        this.allCourseList = res.data[0].courses;
        this.dateWeekList = res.data[0].date;

        let mondayList = [];
        let TuesdayList = [];
        let WednesdayList = [];
        let ThursdayList = [];
        let FridayList = [];
        let SaturdayList = [];
        let SundayList = [];
        for (let i of this.allCourseList) {
          for (let j of i) {
            j.current = 0;
          }
        }
        //周一
        mondayList.push(this.allCourseList[0]);
        //周二
        TuesdayList.push(this.allCourseList[1]);
        //周三
        WednesdayList.push(this.allCourseList[2]);
        //周四
        ThursdayList.push(this.allCourseList[3]);
        //周五
        FridayList.push(this.allCourseList[4]);
        //周六
        SaturdayList.push(this.allCourseList[5]);
        //周日
        SundayList.push(this.allCourseList[6]);

        let calStart = res.data[0].date[0].xqmc;
        if (calStart == "日") {
          this.mondayList = mondayList;
          this.TuesdayList = TuesdayList;
          this.WednesdayList = WednesdayList;
          this.ThursdayList = ThursdayList;
          this.FridayList = FridayList;
          this.SaturdayList = SaturdayList;
          this.SundayList = SundayList;
        } else if (calStart == "一") {
          this.mondayList = TuesdayList;
          this.TuesdayList = WednesdayList;
          this.WednesdayList = ThursdayList;
          this.ThursdayList = FridayList;
          this.FridayList = SaturdayList;
          this.SaturdayList = SundayList;
          this.SundayList = mondayList;
        } else if (calStart == "二") {
          this.mondayList = WednesdayList;
          this.TuesdayList = ThursdayList;
          this.WednesdayList = FridayList;
          this.ThursdayList = SaturdayList;
          this.FridayList = SundayList;
          this.SaturdayList = mondayList;
          this.SundayList = TuesdayList;
        } else if (calStart == "三") {
          this.mondayList = ThursdayList;
          this.TuesdayList = FridayList;
          this.WednesdayList = SaturdayList;
          this.ThursdayList = SundayList;
          this.FridayList = mondayList;
          this.SaturdayList = TuesdayList;
          this.SundayList = WednesdayList;
        } else if (calStart == "四") {
          this.mondayList = FridayList;
          this.TuesdayList = SaturdayList;
          this.WednesdayList = SundayList;
          this.ThursdayList = mondayList;
          this.FridayList = TuesdayList;
          this.SaturdayList = WednesdayList;
          this.SundayList = ThursdayList;
        } else if (calStart == "五") {
          this.mondayList = SaturdayList;
          this.TuesdayList = SundayList;
          this.WednesdayList = mondayList;
          this.ThursdayList = TuesdayList;
          this.FridayList = WednesdayList;
          this.SaturdayList = ThursdayList;
          this.SundayList = FridayList;
        } else if (calStart == "六") {
          this.mondayList = SundayList;
          this.TuesdayList = mondayList;
          this.WednesdayList = TuesdayList;
          this.ThursdayList = WednesdayList;
          this.FridayList = ThursdayList;
          this.SaturdayList = FridayList;
          this.SundayList = SaturdayList;
        }
      }
    },
    classList3(arr, newArr) {
      for (let i in arr) {
        let abc = arr[i];
        let Num;
        for (let n in newArr) {
          if (abc.weekNoteDetail.length == "3") {
            Num = abc.weekNoteDetail.slice(-2);
            if (newArr[n].a == Num) {
              newArr[n] = abc;
            }
          }
        }
      }
      return newArr;
    },
    async getWeek() {
      let concatList1 = [];
      let concatList2 = [];
      const params = {
        semester: ""
      };
      const res = await Api.getTeachingWeek(params);
      for (let i = 0; i < res.data.length; i++) {
        concatList1 = concatList1.concat("第" + res.data[i].week + "周");
        concatList2 = concatList2.concat(res.data[i].week);
      }
      if (this.schoolCode == "10008" || this.schoolCode == "10759"||this.schoolCode == "10488") {
        concatList1.unshift("全部");
      }
      this.columns[0].values = concatList1;

      if(this.schoolCode == "10894"){
        let obj = {};
        obj.className = "column2";
        let xnxqArr= [];
        let xnxqidArr= [];
        for (let i = 0; i < res.xnxqList.length; i++) {
          xnxqArr = xnxqArr.concat(res.xnxqList[i].semesterName);
          xnxqidArr = xnxqidArr.concat(res.xnxqList[i].semesterId);
        }
        obj.values =xnxqArr;
        this.columns.push(obj)
        this.xnxqidArr = xnxqidArr;
      }
      this.zcList = concatList2;
    },
    tableRowClassName1({ row, rowIndex }) {
      console.log(rowIndex % 2)
      if (rowIndex % 2 === 1) {
        return 'gray-row';
      }
      return '';
    },
    to_hsbz(){
      if(this.bz_show){
        this.bz_show = false;
      }else{
        this.bz_show = true
      }
    }
  },
  created() {
    this.schoolCode = sessionStorage.getItem("schoolCode");
    if (this.schoolCode == "10008" || this.schoolCode == "10488" ) {
      this.curWeek = "全部";
    }
    //needClassName
    this.loadClass();
    //教学周次
    this.getWeek();
    this.timeModeTap();
  },
  mounted() {
    if(this.schoolCode == '10045'){
      window.addEventListener('scroll',this.hiddenXskc,true);
    }
    setTimeout(() => {
      if (this.$refs.ranText) {
        for (let i = 0; i < this.$refs.ranText.length; i++) {
          if (
            this.$refs.ranText[i].children &&
            this.$refs.ranText[i].children.length == 3
          ) {
            this.$refs.ranText[i].children[2].style.color = this.$refs.ranText[
              i
            ].style.backgroundColor;
          }
        }
      }
    }, 250);
  }
};
</script>

<style lang="less" scoped>
.footerparndiv {
  display: flex;
  flex-direction: row;
  height: 7rem;
  width: 100%;
  .bottomleftdiv {
    display: block;
    line-height: 3rem;
    color: #757dac;
    p {
      margin-left: 10px;
    }
    //  border-right: 0.3px solid #D0D4E5;
    width: 20%;
    height: 4rem;
    margin-bottom: 3rem;
    background-color: #f4f5ff;
  }
  .bottomrightdiv {
    display: block;
    width: 80%;
    color: red;
    font-size: 10px;
    height: 4rem;
    margin-bottom: 3rem;
    background-color: #f4f5ff;
  }
}

.timetable1 {
  .timetable_top1 {
    /deep/.van-field__control {
      color: #ffffff;
    }
  }
  .popup {
    i.close-pop {
      background: url(../../../../static/img/close.png) no-repeat center;
      position: absolute;
      right: 10px;
      top: 10px;
      background-size: 20px 20px;
      width: 20px;
      height: 20px;
      padding: 10px;
    }
  }
  .link-item {
    text-decoration: underline;
    word-break: break-all;
  }
}
.timetable1 .van-popup.van-popup--center {
  box-sizing: border-box;
  padding: 40px 20px 20px;
  width: 90%;
  border-radius: 5px;
}
.timetable1 .van-popup.van-popup--center .popup-content {
  margin-bottom: 20px;
}
.timetable1 .van-popup.van-popup--center .popup-content > h2 {
  color: @attendance-color-1;
  font-size: 16px;
  text-align: center;
  font-weight: bold;
  margin-bottom: 20px;
  position: relative;
}
.timetable1 .van-popup.van-popup--center .popup-content > div {
  color: @attendance-background-color-1;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
}
.timetable1 .van-popup.van-popup--center .popup-content > p {
  color: @attendance-color-2;
  font-size: 16px;
  line-height: 30px;
}
.timetable1 .popup button {
  background-color: @attendance-background-color-7;
  color: @attendance-background-color-1;
  padding: 11px 0;
  border-radius: 3px;
  width: 100%;
  margin-top: 50px;
}
.timetable1 .van-popup.van-popup--center .popup-content > p > span {
  font-weight: bold;
}
.timetable1 .timetable_top1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: @attendance-background-color-1;
  padding: 10px 15px;
}
.timetable1 .timetable_top1 select {
  color: @attendance-color-3;
  border: 0;
  background: none;
  outline: none;
}
.timetable1 .timetable_top1 .currentTime {
  width: 25px;
  height: 25px;
  line-height: 25px;
  font-weight: 300;
  color: @attendance-color-3;
  font-size: 14px;
  text-align: center;
  border-radius: 50%;
  background: @attendance-background-color-8;
}
.timetable1 .timetable_list {
  display: flex;
  background-color: @attendance-background-color-6;
}
.timetable1 .timetable_list .period > div {
  border: 1px solid @attendance-border-color-5;
  border-bottom: 0;
  box-sizing: border-box;
  font-size: 14px;
  text-align: center;
  box-shadow: 1px 1px 4px 0px rgba(62, 53, 167, 0.26);
  background: @attendance-border-color-5;
  color: @attendance-color-3;
  box-shadow: 1px 1px 4px 0px rgba(62, 53, 167, 0.26);
  height: 60px;
  width: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.timetable1 .timetable_list .period ul li {
  height: 70px;
  text-align: center;
  line-height: 70px;
}
.timetable1 .el-tabs__nav .is-top {
  background: @attendance-border-color-5;
  color: @attendance-color-3;
}
.timetable1 .table_list ul li {
  width: 62px;
  height: 115px;
  background: @attendance-background-color-9;
  color: @attendance-color-3;
  box-sizing: border-box;
  padding: 5px;
  font-size: 12px;
  border-radius: 2px;
}
.timetable1 .timetable_top1 .van-cell {
  background-color: @attendance-background-color-1 !important;
  color: @attendance-color-3;
  padding: 0;
  width: 15%;
}
.timetable1 .timetable_top1 .van-field__body .van-field__control {
  color: @attendance-color-3 !important;
}
.timetable1 .timetable_top1 .van-cell:not(:last-child)::after {
  border-bottom: 0;
}
.timetable1 .week-arrow {
  background: url(../../../../static/img/week.png) no-repeat center;
  width: 7px;
  height: 4px;
  background-size: 7px 4px;
  position: absolute;
  left: 70px;
}
.timetable1
  .timetable1
  .timetable_top1
  .van-ellipsis.van-picker-column__item.van-picker-column__item--selected {
  color: @attendance-color-1;
  font-weight: 600;
}
.timetable1 .table-right {
  flex: 1;
  overflow-x: scroll;
  overflow-y:hidden;
}
.timetable1 .table-right .week-nav ul li {
  flex-direction: column;
  height: 60px;
  background-color: @attendance-border-color-5;
  color: @attendance-color-3;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15%;
}
.timetable1 .table-right .week-nav ul li > p {
  font-size: 14px;
  margin-top: 3px;
}
.timetable1 .table-right .week-nav ul {
  display: flex;
  border-bottom: 1px solid @attendance-color-3;
  min-width: 435px;
  max-width: 100%;
}
.timetable1 .el-tabs__nav {
  width: 100%;
}
.timetable1 .period ul li {
  color: @attendance-color-2;
}
.timetable1 .course-content {
  display: flex;
  min-width: 435px;
  max-width: 100%;
}
.timetable1 .course-form {
  width: 15%;
  position: relative;
}
.timetable1 .course-form ul {
  display: flex;
  flex-direction: column;
}
.timetable1 .course-form .myul {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  border-right: 1px solid @attendance-color-3;
}
.timetable1 .course-form .myul li {
  overflow: hidden;
  width: calc(~"100% - 1px");
  position: relative;
  height: 139px;
  color: @attendance-color-3;
  font-size: 12px;
  margin-bottom: 1px;
  border-radius: 4px;
  position: absolute;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  /* -webkit-line-clamp: 8; */
  box-sizing: border-box;
  margin-right: 1px;
}
.timetable1 .course-form .myul li > p {
  border-radius: 9px;
  background-color: rgba(255, 255, 255, 0.5);
  font-size: 10px;
  text-align: center;
  padding: 2px 0;
  position: absolute;
  bottom: 4px;
  left: 2px;
  width: calc(~"100% - 4px");
  box-sizing: border-box;
  line-height: 14px;
}
.timetable1 .pos_item {
  position: absolute;
  top: 0;
  left: -9px;
}
.timetable1 .pos_item li {
  width: 58px;
  height: 65px;
  color: @attendance-color-3;
  margin-bottom: 1px;
  border-radius: 4px 4px 4px 4px;
  font-size: 12px;
  padding: 4px;
}
/* 时间模式 */
.time-right {
  display: flex;
  justify-content: flex-end;
  position: relative;
}
.time-right .van-cell {
  width: calc(~"80% - 25px") !important;
}
.time-right .van-field__control {
  text-align: right;
  padding-right: 25px;
}
.time-right i.week-arrow {
  right: 35px;
  left: unset;
  height: 100%;
}

.popup_student {
  i.close-pop {
    background: url(../../../../static/img/close.png) no-repeat center;
    position: absolute;
    right: 0;
    top: -10px;
    background-size: 20px 20px;
    width: 20px;
    height: 20px;
    padding: 10px;
  }
}
.set-part {
  display: flex;
  justify-content: space-between;
}
.set-part > div {
  width: 48%;
}
.set-part-p {
  text-align: left;
}
.timetable1 .ul-student {
  width: 99%;
}
.timetable1 .li-student {
  width: 33%;
  float: left;
  font-size: 15px;
}
.student-tittle-div {
  margin-top: -10px;
}
.student-context-div {
  margin: 0px;
}
.li-student-context {
  width: 33%;
  float: left;
  font-size: 12px;
  color: black;
}
.ul-student-context {
  width: 99%;
  line-height: 20px;
}
.div-backclor1 li {
  background-color: gainsboro;
}
.div-backclor2 li {
  background-color: antiquewhite;
}
.my-swipe {
  width: 100%;
  height: 100%;
  .van-swipe-item {
    padding: 8px 4px;
    box-sizing: border-box;
    color: #fff;
    margin-right: 1px;
  }
}
.custom-indicator {
  position: absolute;
  right: 5px;
  bottom: 5px;
  padding: 2px 5px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.1);
  color: #fff;
}
.xskcxsPopup{
    width: 334px;
    margin-bottom: 68px;
    margin-left: 12px;
    height: 90px;
    background: #7469f8cc;
    opacity: 0.8;
    box-shadow: 0 3px 6px 0 #5f54e040;
    border-radius: 8px;
    position: fixed;
    bottom: 0;
    padding: 15px;
    z-index: 100;
  }
  .xskcxsPopup_bz{
    background: #7469F8;
    z-index: 9999;
    color: #fff;
    padding: 5px 0px 5px 0px;
    min-height: 80px;
    max-height: 160px;
    width: calc(~"100% - 36px");
    height: 120px;
    overflow-y: auto;
    left: 20px;
    bottom: 60px;
    border-radius: 5px 0px 0px 5px !important;
  }
  .van-popup-parm{
    width: 100%;
    height: 120px;
    z-index: 1000;
  }
  .xskcxsPopup_bz_context{
      font-size: 14px;
      
    }
  .xskcxsPopup_bz_button{
    width: 10px;
    height: 120px;
    line-height: 120px;
    background: #7469F8;
    z-index: 11111;
    border-radius: 8px;
    color: #fff;
    padding-top: 5px;
    padding-bottom: 5px;
    min-height: 80px;
    max-height: 160px;
    height: 120px;
    overflow-y: auto;
    border-radius: 0px 5px 5px 0px !important;
    left: calc(~"100% - 20px");
    bottom: 60px;
  }  

  .xskcxsPopup .xskcxsPopuptitle{
      color: #fff;
      font-family: PingFangSc-Medium;
      font-weight: 400;
      font-size: 14px;
      float: left;
  }
  .xskcxsPopup .xskcxsPopupxx{
      color: #fff;
      font-family: PingFangSc-Regular;
      font-weight: 400;
      font-size: 12px;
      float: right;
  }
  .xskcxsPopup > div{
      width: 334px;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 3;
      display: -webkit-box;
      color: #fff;
      -webkit-box-orient: vertical;
      font-size: 12px;
      line-height: 20px;
  }
  .xskcpopup{
    margin-left: 39px;
    background: #FFF;
    box-shadow: 0 3px 6px 0 #5f54e040;
    border-radius: 8px;
    position: fixed;
    bottom: 250px;
    width: 311px;
    height: 382px;
    z-index: 100;
  }

  .timetable1 .xskcpopup button {
    background-color: @attendance-background-color-7;
    color: @attendance-background-color-1;
    padding: 11px 0;
    border-radius: 3px;
    width: 100%;
    margin-top: 50px;
  }

  .timetable1 .xskcpopup .popup-title {
    background: url(../../../../static/img/chahua.png) no-repeat center;
    width: 100%;
    height: 64px;
  }

  .timetable1 .xskcpopup .popup-title > span{
    color: #fff;
    font-size: 18px;
    line-height: 64px;
    margin-left: 28px;
  }

  .timetable1 .xskcpopup .popup-context {
    margin-top: 10px;
    margin-left: 18px;
    line-height: 20px;
    width: 276px;
    height: 216px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }
  .timetable1 .xskcpopup .popup-float {
   
    width: 100%;
    height: 50px;
  }
  
  /deep/.el-table .gray-row,
  .child-table th {
      background-color: #F6F6F6;
  }

 
</style>



// WEBPACK FOOTER //
// src/components/teacher/Class/surfaces.vue